<template>
    <div>

    <!--
    <button type="button"
    class="btn btn-primary m-2 fload-end"
    data-bs-toggle="modal"
    data-bs-target="#exampleModal"
    @click="addClick()">
    Agregar un comentario
    </button>
    -->

    <table class="table table-striped">

        <thead>

            <tr>

                <!--<th>ID</th>-->
                <th>
                    <div class="d-flex flex-row">

                    <input class="form-control m-2"
                    v-model="AutorFilter"
                    v-on:keyup="FilterAutor()"
                    placeholder="Filtrar">
                    
                    <button type="button" class="btn btn-light"
                    @click="sortResult('Autor',true)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
                    <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
                    </svg>
                    </button>
                    &nbsp;
                    <button type="button" class="btn btn-light"
                    @click="sortResult('Autor',false)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
                    <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
                    </svg>
                    </button>

                    </div>
                    Autor
                </th>
                <th>Email</th>
                <th>Institución</th>
                <th>
                    <div class="d-flex flex-row">

                    <input class="form-control m-2"
                    v-model="ComentarioFilter"
                    v-on:keyup="FilterFn()"
                    placeholder="Filtrar">
                    
                    <button type="button" class="btn btn-light"
                    @click="sortResult('Comentario',true)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
                    <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
                    </svg>
                    </button>
                    &nbsp;
                    <button type="button" class="btn btn-light"
                    @click="sortResult('Comentario',false)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
                    <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
                    </svg>
                    </button>

                    </div>
                    Comentarios
                </th>
                <th>Opciones</th>

            </tr>

        </thead>

        <tbody>
            <tr v-for="(com, index) in comentarios" :key="index">

               <!-- <td>{{com.ComentarioID}}</td>-->
                <td>{{com.Autor}}</td>
                <td>{{com.Email}}</td>
                <td>{{com.Institution}}</td>
                <td>{{com.Comentario}}</td>

                <td>
                <b-button v-b-modal.modal-ed variant="light" @click="editClick(com)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-reply-fill" viewBox="0 0 16 16">
                    <path d="M5.921 11.9 1.353 8.62a.719.719 0 0 1 0-1.238L5.921 4.1A.716.716 0 0 1 7 4.719V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z"/>
                    </svg>
                </b-button>
                &nbsp;
                <b-button @click="deleteClick(com.ComentarioID)" variant="light">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                    <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                    </svg>
                </b-button>

                </td>

            </tr>
        </tbody>

    </table>

    <b-modal id="modal-ed" size="lg" hide-footer hide-header centered>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{modalTitle}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="$bvModal.hide('modal-ed')">
                </button>
            </div>


        <div class="modal-body">

            <div>
                
                <p>

                    <span class="input-group-text">Autor</span> <span class="input-group-text">{{Autor}}</span> <!--<input type="text" class="form-control" v-model="Autor">-->
                        
                    &nbsp;
                        
                    <span class="input-group-text">Email</span> <span class="input-group-text">{{Email}}</span> <!--<input type="text" class="form-control" v-model="Email">-->
                        
                    &nbsp;
                        
                    <span class="input-group-text">Institución</span> <span class="input-group-text">{{Institution}}</span> <!--<input type="text" class="form-control" v-model="Institution">-->
                        
                    &nbsp;
                        

                    <span class="input-group-text">Comentario</span>
                    <span class="input-group-text">{{Comentario}}</span>
                    <!--<textarea class="form-control" v-model="Comentario" aria-label="Comentario"></textarea>-->
                    
                    &nbsp;

                    <span class="input-group-text">Respuesta</span>
                    <textarea class="form-control" v-model="Respuesta" aria-label="Respuesta"></textarea>

                </p>
            </div>
            &nbsp;
            <div>
                <button type="button" @click="createClick()"
                v-if="ComentarioID==0" class="btn btn-primary">
                Agregar
                </button>
                <button type="button" @click="updateClick()"
                v-if="ComentarioID!=0" class="btn btn-primary">
                Responder
                </button>
            </div>
        </div>

    
    </b-modal>


    </div>
</template>

<script>

import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';

import axios from 'axios';

export default {

    data(){

    return{
        user:'',
        comentarios:[],
        modalTitle:"",
        Comentario:"",
        ComentarioID:0,
        Respuesta:"",
        Autor:"",
        Email:"",
        Institution:"",
        ComentarioFilter:"",
        AutorFilter:"",
        ComentarioIDFilter:"",
        ComentariosWithoutFilter:[]
    }
    },

    created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      } else {
        this.$router.push('/admin')
      }
    });
  },

    methods:{
        refreshData(){
            axios.get("http://difraco.com.co:8000/blog")
            .then((response)=>{
                this.comentarios=response.data;
                this.comentariosWithoutFilter=response.data;
            })
        },

        addClick(){
            this.modalTitle="Agregar un comentario";
            this.ComentarioID=0;
            this.Comentario="";
            this.Respuesta="";
            this.Autor="";
            this.Email="";
            this.Institution=""
        },
        editClick(com){
            this.modalTitle="Responder comentario";
            this.ComentarioID=com.ComentarioID;
            this.Comentario=com.Comentario;
            this.Respuesta=com.Respuesta;
            this.Autor=com.Autor;
            this.Email=com.Email;
            this.Institution=com.Institution
        },
        createClick(){
            axios.post("http://difraco.com.co:8000/blog",{
                Comentario:this.Comentario,
                Respuesta:this.Respuesta,
                Autor:this.Autor,
                Email:this.Email,
                Institution:this.Institution
            })
            .then((response)=>{
                this.refreshData();
                alert(response.data);
            });
        },
        updateClick(){
            axios.put("http://difraco.com.co:8000/blog",{
                ComentarioID:this.ComentarioID,
                Comentario:this.Comentario,
                Respuesta:this.Respuesta,
                Autor:this.Autor,
                Email:this.Email,
                Institution:this.Institution
            })
            .then((response)=>{
                this.refreshData();
                alert(response.data);
            });
        },
        deleteClick(id){
            if(!confirm("¿Está seguro de que quiere borrar?")){
                return;
            }
            axios.delete("http://difraco.com.co:8000/blog/"+id)
            .then((response)=>{
                this.refreshData();
                alert(response.data);
            });

        },
        FilterFn(){
            var ComentarioIDFilter=this.ComentarioIDFilter;
            var ComentarioFilter=this.ComentarioFilter;

            this.comentarios=this.comentariosWithoutFilter.filter(
                function(el){
                    return el.ComentarioID.toString().toLowerCase().includes(
                        ComentarioIDFilter.toString().trim().toLowerCase()
                    )&&
                    el.Comentario.toString().toLowerCase().includes(
                        ComentarioFilter.toString().trim().toLowerCase()
                    )
                });
        },
        FilterAutor(){
            var AutorFilter=this.AutorFilter;

            this.comentarios=this.comentariosWithoutFilter.filter(
                function(el){
                    return el.Autor.toString().toLowerCase().includes(
                        AutorFilter.toString().trim().toLowerCase()
                    )
                });
        },
        sortResult(prop,asc){
            this.comentarios=this.comentariosWithoutFilter.sort(function(a,b){
                if(asc){
                    return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
                }
                else{
                    return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
                }
            })
        },
    },

    mounted:function(){
        this.refreshData();
    }


};
</script>
